/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Heading,
    SimpleGrid
} from '@salesforce/retail-react-app/app/components/shared/ui'
import ProductTile from '../product-tile'

const ShopTheLookServerOnly = ({
    products,
    title,
    titleStyle,
    productTitleStyle,
    productPriceStyle
}) => {
    // No-JS SSR: render only when products are available from server prefetch.
    if (!products?.length) return null

    return (
        <Box>
            {title && (
                <Heading as="h2" fontSize="lg" mb={4} sx={titleStyle}>
                    {title}
                </Heading>
            )}
            <SimpleGrid columns={2} spacing={4}>
                {products.map((product, idx) => (
                    <ProductTile
                        key={product?.id || idx}
                        product={product}
                        disableImageScroll={true}
                        enableFavourite={true}
                        showQV={false}
                        productTitleStyle={productTitleStyle}
                        productPriceStyle={productPriceStyle}
                    />
                ))}
            </SimpleGrid>
        </Box>
    )
}

ShopTheLookServerOnly.propTypes = {
    products: PropTypes.array,
    title: PropTypes.string,
    titleStyle: PropTypes.object,
    productTitleStyle: PropTypes.object,
    productPriceStyle: PropTypes.object
}

export default ShopTheLookServerOnly
